import {Box} from '@mui/material'
import styled from 'styled-components'
import {colors} from '../../../../styles/theme'

export const ButtonsBox = styled(Box)`
  display: flex;
  justify-content: center;
  margin-top: 24px;
  flex-wrap: wrap;
  gap: 16px;
`

export const StyledButton = styled(Box)`
  display: flex;
  gap: 10px;
  padding: 0 24px;
  align-items: center;
  height: 40px;
  font-size: 14px;
  color: ${colors.blue1};
  border: 1px solid ${colors.blue1};
  background: #fff;
  cursor: pointer;
  border-radius: 2px;
  font-weight: 700;
  box-sizing: border-box;

  &:hover {
    background: ${colors.blue1};
    color: #fff;
  }
`
